import { render, staticRenderFns } from "./AplicacionDia2.vue?vue&type=template&id=013c24d0&"
import script from "./AplicacionDia2.vue?vue&type=script&lang=js&"
export * from "./AplicacionDia2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports